import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Link ellenőrzése...", -1)
const _hoisted_3 = {
  key: 1,
  class: "text-center"
}

import AuthLayout from "@/components/layout/AuthLayout.vue";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { PasswordResetService } from "@/services/PasswordResetService";
import { useToast } from "@/services/useToast";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordResetView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const passwordResetService = new PasswordResetService();
const { showToast } = useToast();

const token = ref("");
const password = ref("");
const passwordConfirm = ref("");
const visible = ref(false);
const loading = ref(true);
const tokenError = ref(false);
const submitting = ref(false);
const formRef = ref<{ validate: () => Promise<{ valid: boolean }> } | null>(
  null
);

const rules = {
  required: (v: string) => !!v?.trim() || "Kötelező mező",
  minPassword: (v: string) =>
    v?.length >= 8 || "A jelszónak legalább 8 karakter hosszúnak kell lennie",
  passwordMatch: (v: string) =>
    v === password.value || "A jelszavak nem egyeznek",
};

onMounted(async () => {
  token.value = (route.query.token as string) ?? "";
  if (!token.value) {
    tokenError.value = true;
    loading.value = false;
    return;
  }
  try {
    await passwordResetService.validateToken(token.value);
  } catch {
    tokenError.value = true;
  } finally {
    loading.value = false;
  }
});

async function submit() {
  const { valid } = await formRef.value!.validate();
  if (!valid) return;

  submitting.value = true;
  try {
    const { role } = await passwordResetService.confirmReset(
      token.value,
      password.value
    );
    showToast("A jelszót sikeresen megváltoztattuk");
    router.push(role === "ADMIN" ? "/admin/login" : "/login");
  } catch (e: any) {
    const status = e?.response?.status;
    if (status === 400) {
      // The token expired or was already used between page load and submit.
      tokenError.value = true;
    } else if (status === 422) {
      showToast("A megadott jelszó nem felel meg a követelményeknek", "error");
    } else {
      showToast("A jelszó mentése sikertelen. Kérjük, próbálja újra.", "error");
    }
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(AuthLayout, { "max-width": 480 }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              class: "mb-4"
            }),
            _hoisted_2
          ]))
        : (tokenError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                color: "error",
                size: "56",
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-alert-circle")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_title, { class: "justify-center mb-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("Érvénytelen link")
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createTextVNode(" A jelszó visszaállító link érvénytelen vagy lejárt. Kérjen újat a bejelentkezési oldalon. ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                to: "/forgot-password"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Új link kérése")
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_v_card_title, { class: "mb-2" }, {
                default: _withCtx(() => [
                  _createTextVNode("Új jelszó megadása")
                ]),
                _: 1
              }),
              _createVNode(_component_v_form, {
                ref_key: "formRef",
                ref: formRef,
                onSubmit: _withModifiers(submit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                        label: "Új jelszó",
                        "append-inner-icon": visible.value ? 'mdi-eye-off' : 'mdi-eye',
                        type: visible.value ? 'text' : 'password',
                        density: "compact",
                        variant: "outlined",
                        "prepend-inner-icon": "mdi-lock-outline",
                        class: "mb-2",
                        autofocus: "",
                        rules: [rules.required, rules.minPassword],
                        "onClick:appendInner": _cache[1] || (_cache[1] = ($event: any) => (visible.value = !visible.value))
                      }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: passwordConfirm.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordConfirm).value = $event)),
                        label: "Új jelszó megerősítése",
                        type: visible.value ? 'text' : 'password',
                        density: "compact",
                        variant: "outlined",
                        "prepend-inner-icon": "mdi-lock-outline",
                        rules: [rules.required, rules.passwordMatch]
                      }, null, 8, ["modelValue", "type", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        type: "submit",
                        color: "primary",
                        loading: submitting.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Jelszó mentése")
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512)
            ], 64))
    ]),
    _: 1
  }))
}
}

})